import loadScript from 'load-script';

import './youtubeEmbed.html.twig';
import './youtubeEmbed.css';

const ytapi = 'https://www.youtube.com/iframe_api';

window.byoutubeList = window.byoutubelist || [];

let prevOnReady = () => {};

if (typeof window.onYouTubeIframeAPIReady === 'function') {
  prevOnReady = window.onYouTubeIframeAPIReady;
}

function YouTubeGetID(url) {
  let ID = '';
  url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (url[2] !== undefined) {
    ID = url[2].split(/[^0-9a-z_\-]/i);
    ID = ID[0];
  } else {
    ID = url;
  }
  return ID;
}

function onPlayerReady(event) {
  const videoIframe = event.target.getIframe();
  const videoParent = videoIframe.parentElement;
  const playButton = videoParent.nextElementSibling;

  playButton.addEventListener('click', () => {
    event.target.playVideo();
    playButton.style.display = 'none';
    videoParent.classList.add('youtube-embed__video--playing');
  });
}

window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
  Array.from(window.byoutubeList).forEach(el => {
    const pel = el.parentElement;
    const player = new YT.Player(el, {
      videoId: YouTubeGetID(el.getAttribute('data-youtube')),
      width: '100%',
      height: '100%',
      playerVars: {
        rel: 0,
        showinfo: 0,
        modestbranding: 1,
        autohide: 1,
      },
      events: {
        onReady: onPlayerReady,
      },
    });
    pel.play = () => player.playVideo();
    pel.pause = () => player.pauseVideo();
  });
};

export default function() {
  const el = document.querySelector('.youtube-embed');
  if (!el) {
    return;
  }

  const videoBlocks = document.querySelectorAll('.youtube-embed');

  [...videoBlocks].forEach(vb => {
    const video = vb.querySelector('.youtube-embed__video');

    if (video.firstElementChild.hasAttribute('data-youtube')) {
      window.byoutubeList.push(video.firstElementChild);
    }
  });

  if (window.byoutubeList.length) {
    loadScript(ytapi, () => {}, { async: true });
  }
}
